import bannerImage from "../../assets/images/category-banners/cups.png";

export default {
  h1Text: `Создай свою кружку с надписью, фотографией или логотипом`,
  h2Text: ``,
  regularTextHtml: `
  <h3>Печать рисунков, логотипов и надписей на кружках<br> методом сублимации от 1 шт.<br><br> Создай свой дизайн.</h3>
  <p>Кружка с логотипом, надписью или рисунком это идеальный подарок на любой праздник. Это не просто сувенир, но и по настоящему полезная вещь, которая будет долго напоминать ее владельцу о важном событии в жизни. Нанесение рисунка на кружку делается методом сублимации, что позволяет полностью передать яркость и сочность красок. С помощью нашего конструктора кружек вы сможете с легкостью сделать дизайн от ручки до ручки. Выбирайте, создавайте и заказывайте с Printio.</p>`,
  buttonText: `Выбрать кружку`,
  image: [bannerImage]
};
